import { render, staticRenderFns } from "./surrenderList.vue?vue&type=template&id=b38ac26c&scoped=true&"
import script from "./surrenderList.vue?vue&type=script&lang=js&"
export * from "./surrenderList.vue?vue&type=script&lang=js&"
import style0 from "./surrenderList.vue?vue&type=style&index=0&id=b38ac26c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38ac26c",
  null
  
)

export default component.exports